import {
  faKey,
  faLock,
  faEye,
  faEyeSlash
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CreateEmployeeFormData } from 'data/from-data/create-employee-form.data';
import { Employee } from 'data/users';
import React, { ChangeEvent, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';

interface SettingsChangePasswordType {
  authUser?: Employee;
  formData?: CreateEmployeeFormData;
  handleInputChange?: (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => void;
}

const SettingsChangePassword = ({
  authUser,
  formData,
  handleInputChange
}: SettingsChangePasswordType) => {
  const location = useLocation();
  const [showPasswords, setShowPasswords] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false
  });
  const [confirmPassword, setConfirmPassword] = useState('');

  const togglePasswordVisibility = (field: keyof typeof showPasswords) => {
    setShowPasswords(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleConfirmPasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setConfirmPassword(value);

    if (formData?.password.value && value !== formData.password.value) {
      toast.error('Passwords do not match');
    } else {
      toast.dismiss();
    }
  };

  return (
    <>
      <h4 className="mb-4">Change Password</h4>
      {location.pathname === 'profile' && !authUser?.isAdmin && (
        <>
          <div className="form-icon-container mb-3 position-relative">
            <Form.Floating>
              <Form.Control
                id="oldPassword"
                type={showPasswords.oldPassword ? 'text' : 'password'}
                placeholder="Old Password"
                className="form-icon-input pe-5"
                name="OldPassword"
                onChange={handleInputChange}
                required
              />
              <label htmlFor="oldPassword" className="form-icon-label text-700">
                OLD PASSWORD
              </label>
            </Form.Floating>
            <FontAwesomeIcon
              icon={faLock}
              className="text-900 fs-9 form-icon"
            />
            <button
              type="button"
              className="btn btn-link position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent"
              onClick={() => togglePasswordVisibility('oldPassword')}
            >
              <FontAwesomeIcon
                icon={showPasswords.oldPassword ? faEyeSlash : faEye}
                className="text-700"
              />
            </button>
          </div>
          <div className="form-icon-container mb-3 position-relative">
            <Form.Floating>
              <Form.Control
                id="newPassword"
                type={showPasswords.newPassword ? 'text' : 'password'}
                placeholder="New password"
                className="form-icon-input pe-5"
                name="newPassword"
                onChange={handleInputChange}
                required
              />
              <label htmlFor="newPassword" className="form-icon-label text-700">
                NEW PASSWORD
              </label>
            </Form.Floating>
            <FontAwesomeIcon icon={faKey} className="text-900 fs-9 form-icon" />
            <button
              type="button"
              className="btn btn-link position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent"
              onClick={() => togglePasswordVisibility('newPassword')}
            >
              <FontAwesomeIcon
                icon={showPasswords.newPassword ? faEyeSlash : faEye}
                className="text-700"
              />
            </button>
          </div>
        </>
      )}
      <div className="form-icon-container mb-3 position-relative">
        <Form.Floating>
          <Form.Control
            id="newPassword2"
            type={showPasswords.confirmPassword ? 'text' : 'password'}
            placeholder="Confirm New password"
            className="form-icon-input pe-5"
            name="password"
            value={formData?.password.value}
            onChange={handleInputChange}
            required
          />
          <label htmlFor="newPassword2" className="form-icon-label text-700">
            {authUser?.isAdmin ? 'NEW PASSWORD' : 'CONFIRM NEW PASSWORD'}
          </label>
        </Form.Floating>
        <FontAwesomeIcon icon={faKey} className="text-900 fs-9 form-icon" />
        <button
          type="button"
          className="btn btn-link position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent"
          onClick={() => togglePasswordVisibility('confirmPassword')}
        >
          <FontAwesomeIcon
            icon={showPasswords.confirmPassword ? faEyeSlash : faEye}
            className="text-700"
          />
        </button>
      </div>
      <div className="form-icon-container position-relative">
        <Form.Floating>
          <Form.Control
            id="confirmPassword"
            type={showPasswords.confirmPassword ? 'text' : 'password'}
            placeholder="Confirm Password"
            className="form-icon-input pe-5"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            required
          />
          <label htmlFor="confirmPassword" className="form-icon-label text-700">
            CONFIRM PASSWORD
          </label>
        </Form.Floating>
        <FontAwesomeIcon icon={faKey} className="text-900 fs-9 form-icon" />
        <button
          type="button"
          className="btn btn-link position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent"
          onClick={() => togglePasswordVisibility('confirmPassword')}
        >
          <FontAwesomeIcon
            icon={showPasswords.confirmPassword ? faEyeSlash : faEye}
            className="text-700"
          />
        </button>
      </div>
    </>
  );
};

export default SettingsChangePassword;
